module.exports = __webpack_public_path__ + "static/img/history06.ccbb13e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history06.jpg
// module id = JM7R
// module chunks = 1